module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "file-fade"
    }
  }, [_c('div', {
    staticClass: "file-manager"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "dlgdrag",
      rawName: "v-dlgdrag"
    }],
    staticClass: "dig",
    style: ({
      height: _vm.con_height
    })
  }, [_c('div', {
    staticClass: "dig_title clearFix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v(_vm._s(_vm.dig_title))]), _vm._v(" "), _c('Icon', {
    staticClass: "fr",
    attrs: {
      "type": "close-round"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogClose($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dig-main clearFix"
  }, [_c('div', {
    staticClass: "main-left"
  }, [_c('Tabs', {
    on: {
      "on-click": _vm.tabSwitch
    },
    model: {
      value: (_vm.tabtype),
      callback: function($$v) {
        _vm.tabtype = $$v
      },
      expression: "tabtype"
    }
  }, _vm._l((_vm.tabpanes), function(pane, i) {
    return _c('TabPane', {
      key: i,
      style: ({
        height: _vm.con_main_left_height
      }),
      attrs: {
        "name": pane.name,
        "label": pane.alias
      }
    }, [_c('div', {
      staticClass: "tanchuang-content"
    }, [(_vm.items.length) ? [_c('div', {
      staticClass: "tanchuang-content-box"
    }, [_c('div', {
      directives: [{
        name: "bar",
        rawName: "v-bar",
        value: ({
          preventParentScroll: true,
          scrollThrottle: 30
        }),
        expression: "{preventParentScroll: true,scrollThrottle: 30}"
      }],
      staticStyle: {
        "height": "100%"
      }
    }, [_c('div', [_c('ul', {
      staticClass: "main-left-list clearFix"
    }, _vm._l((_vm.items), function(item, i) {
      return _c('li', {
        key: item.id,
        staticClass: "list-li fl"
      }, [_c('div', {
        staticClass: "list-li-top",
        class: {
          selected: _vm.selectedIdx.findIndex(function (v) {
            return v == i
          }) > -1
        },
        staticStyle: {
          "height": "63px",
          "position": "relative",
          "background-color": "#eee"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.imgFocus(i, item.fpath)
          }
        }
      }, [_c('div', {
        staticClass: "loading"
      }), _vm._v(" "), _c('img', {
        directives: [{
          name: "adapt",
          rawName: "v-adapt"
        }],
        attrs: {
          "src": item.ftype.toLowerCase() == 'mp3' ?
            _vm.soundGif : item.fpath,
          "title": '类型：' + item.ftype + '\n大小：' + item.fsize + '\n尺寸：' + item.width + '*' + item.height + '像素\n修改日期：' + item.ftime
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "selectState"
      }, [_c('span', {
        staticClass: "iconfont icon-dui",
        staticStyle: {
          "font-size": "32px"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "list-li-bottom",
        attrs: {
          "title": "双击此处重命名"
        },
        on: {
          "dblclick": function($event) {
            _vm.renameid = i
          }
        }
      }, [(_vm.renameid == i) ? [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.fbasename),
          expression: "item.fbasename"
        }],
        staticClass: "inprename",
        domProps: {
          "value": (item.fbasename)
        },
        on: {
          "keyup": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            _vm.fileRename(i, $event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "fbasename", $event.target.value)
          }
        }
      }), _vm._v(_vm._s(item.fname.replace(/^[^\.]+\./i, '.')))] : [_vm._v(_vm._s(item.fname))]], 2), _vm._v(" "), _c('Icon', {
        staticClass: "list-li-delete",
        staticStyle: {
          "font-size": "10px"
        },
        attrs: {
          "type": "close-round"
        },
        nativeOn: {
          "click": function($event) {
            _vm.fileDelete(item.fname)
          }
        }
      })], 1)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "clearFix"
    }), _vm._v(" "), _c('Page', {
      staticClass: "page-btn",
      attrs: {
        "current": _vm.curr_page,
        "page-size": _vm.page_size,
        "total": _vm.items_total
      },
      on: {
        "on-change": _vm.pageSwitch
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both",
        "height": "2px",
        "width": "100%",
        "overflow": "hidden"
      }
    })], 1)])]), _vm._v(" "), (_vm.getFiles.length) ? _c('div', {
      staticClass: "confirm_btn",
      staticStyle: {
        "bottom": "10px"
      },
      on: {
        "click": _vm.picSelect
      }
    }, [_vm._v("确定(" + _vm._s(_vm.getFiles.length) + ")")]) : _vm._e()] : [_c('span', {
      staticClass: "empty"
    }, [_vm._v(_vm._s(_vm.file_err_str))])]], 2)])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "searchAndOpera"
  }, [(!_vm.getFiles.length) ? _c('div', {
    staticClass: "page_search"
  }, [_c('Input', {
    attrs: {
      "placeholder": "按文件名查找"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fileSearch($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.fileSearch
    },
    slot: "append"
  })], 1)], 1) : _c('div', {
    staticClass: "page_opera"
  }, [(_vm.multiselect) ? [_c('div', {
    staticClass: "opera-list",
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
    staticClass: "opera-list",
    on: {
      "click": _vm.deleteBatch
    }
  }, [_vm._v("批量删除")])] : _vm._e(), _vm._v(" "), _c('Select', {
    staticClass: "opera-list-sele",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "移动至"
    },
    on: {
      "on-change": _vm.fileMoveTo
    }
  }, _vm._l((_vm.categoryTree), function(category) {
    return _c('Option', {
      key: category,
      attrs: {
        "value": category
      }
    }, [_vm._v(_vm._s(_vm.parseTitle(category)))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "opera-list",
    on: {
      "click": _vm.unSelect
    }
  }, [_vm._v("取消选择")])], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main-right fr"
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "page-setup"
  }, [_c('div', {
    staticClass: "upFile"
  }, [_c('Upload', {
    attrs: {
      "accept": _vm.file_accept,
      "max-size": _vm.file_maxsize,
      "on-success": _vm.uploadSuccess,
      "on-exceeded-size": _vm.maxSizeTips,
      "multiple": "",
      "action": _vm.uploadUrl,
      "show-upload-list": false,
      "data": {
        sid: _vm.sid,
        token: _vm.token,
        maxFileSize: _vm.file_maxsize * 1024,
        fileType: _vm.file_allowext,
        tag: _vm.cur_category
      }
    }
  }, [_c('Button', {
    attrs: {
      "type": "success"
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-ios-cloud-upload-outline",
    staticStyle: {
      "font-size": "18px",
      "padding-right": "10px"
    }
  }), _vm._v("\r\n\t\t\t\t\t\t\t\t\t\t上传文件")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "categoryBox"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', [_vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category,
      staticClass: "category-main",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.categorySearch(category)
        }
      }
    }, [_c('div', {
      staticClass: "father",
      class: {
        active: _vm.cur_category == category
      }
    }, [_c('b', {
      staticClass: "mark_choose"
    }), _vm._v(" "), (_vm.renameCtag == category) ? _c('div', [_c('input', {
      staticClass: "catrename",
      attrs: {
        "placeholder": "分类名称"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v(" "), _c('Button', {
      staticClass: "catrename",
      staticStyle: {
        "width": "50px"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.categoryEdit(category, $event)
        }
      }
    }, [_vm._v("确定")])], 1) : _c('div', {
      staticClass: "clearFix",
      staticStyle: {
        "padding-right": "5px"
      }
    }, [(category) ? [(!_vm.subCategoryClose[category]) ? _c('Icon', {
      staticClass: "fl page-setup-father",
      staticStyle: {
        "line-height": "13px"
      },
      attrs: {
        "type": "plus-round"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.branchOpen('plus', category)
        }
      }
    }) : _c('Icon', {
      staticClass: "fl page-setup-father",
      staticStyle: {
        "line-height": "13px"
      },
      attrs: {
        "type": "minus-round"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.branchOpen('minus', category)
        }
      }
    })] : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.parseTitle(category)))]), _vm._v(" "), (category) ? _c('div', {
      staticClass: "fr"
    }, [_c('i', {
      staticClass: "page-setup-li iconfont icon-bianji",
      attrs: {
        "title": "编辑分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showCateInput(category, $event)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "page-setup-li iconfont icon-shezhi1",
      attrs: {
        "title": "设置上级分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.categoryTofather(category)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "page-setup-li iconfont icon-chuyidong",
      attrs: {
        "title": "删除分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.categoryDelete(category)
        }
      }
    })]) : _vm._e()], 2)]), _vm._v(" "), _vm._l((_vm.category_children[category]), function(subcategory) {
      return (_vm.subCategoryClose[category]) ? _c('div', {
        key: subcategory,
        staticClass: "children",
        class: {
          active: _vm.cur_category == subcategory
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.categorySearch(subcategory)
          }
        }
      }, [_c('b', {
        staticClass: "mark_choose"
      }), _vm._v(" "), (_vm.renameCtag == subcategory) ? _c('div', [_c('input', {
        staticClass: "catrename",
        attrs: {
          "placeholder": "分类名称"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }), _vm._v(" "), _c('Button', {
        staticClass: "catrename",
        staticStyle: {
          "width": "56px"
        },
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.categoryEdit(subcategory, $event)
          }
        }
      }, [_vm._v("确定")])], 1) : _c('div', {
        staticClass: "clearFix",
        staticStyle: {
          "padding-right": "5px"
        }
      }, [_c('span', {
        staticStyle: {
          "line-height": "22px"
        }
      }, [_vm._v(_vm._s(_vm.parseTitle(subcategory)))]), _vm._v(" "), _c('div', {
        staticClass: "fr"
      }, [_c('i', {
        staticClass: "page-setup-li iconfont icon-bianji",
        attrs: {
          "title": "编辑分类"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.showCateInput(subcategory, $event)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "page-setup-li iconfont icon-shezhi1",
        attrs: {
          "title": "设置上级分类"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.categoryTofather(subcategory, category)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "page-setup-li iconfont icon-chuyidong",
        attrs: {
          "title": "删除分类"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.categoryDelete(subcategory)
          }
        }
      })])])]) : _vm._e()
    }), _vm._v(" "), (_vm.subCategoryClose[category]) ? _c('div', {
      staticClass: "children",
      staticStyle: {
        "border-bottom": "1px solid #dddee1"
      }
    }, [_c('b', {
      staticClass: "mark_choose"
    }), _vm._v(" "), _c('input', {
      staticClass: "children_ipt",
      attrs: {
        "placeholder": "分类名称"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v(" "), _c('Button', {
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addSubCategory(category, $event)
        }
      }
    }, [_vm._v("确定")])], 1) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.category_err_str) ? _c('div', {
    staticStyle: {
      "color": "#f00",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.category_err_str))]) : _vm._e()], 2)])]), _vm._v(" "), _c('Input', {
    staticClass: "setup-btn",
    attrs: {
      "placeholder": "按Enter键添加分类"
    },
    on: {
      "on-keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addCategory($event)
      }
    },
    model: {
      value: (_vm.catename),
      callback: function($$v) {
        _vm.catename = $$v
      },
      expression: "catename"
    }
  })], 1)])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": 370,
      "title": "设置上级分类"
    },
    on: {
      "on-ok": _vm.superCategorySet
    },
    model: {
      value: (_vm.showSuperCate),
      callback: function($$v) {
        _vm.showSuperCate = $$v
      },
      expression: "showSuperCate"
    }
  }, [_c('ul', {
    staticClass: "supercate-set"
  }, [_c('li', [_c('label', {
    staticClass: "ctitle"
  }, [_vm._v("分类名称")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.parseTitle(_vm.current_cname)))])]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "ctitle"
  }, [_vm._v("上级分类")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.current_fathercname),
      callback: function($$v) {
        _vm.current_fathercname = $$v
      },
      expression: "current_fathercname"
    }
  }, _vm._l((_vm.categories), function(category, c) {
    return _c('Option', {
      key: c,
      attrs: {
        "value": category || 'top'
      }
    }, [_vm._v(_vm._s(_vm.parseTitle(category || '最上层')))])
  }), 1)], 1)])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0f576c25","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/file-manager.vue
// module id = 184
// module chunks = 2